<template>
  <div class="list-page custom-table--detail">
    <div class="layout__content__header list-page__header p-0">
      <CopyNotification
        :opened="copyConfirmVisible"
        :text="'zkopirovanoDoSchranky'"
        @close="copyConfirmVisible = false"
      />
      <div v-if="project" class="d-flex justify-content-between">
        <div class="d-flex list-page__left align-items-center">
          <div
            v-if="project.projectId"
            class="custom-control custom-control--search d-flex align-items-center justify-content-between list-page__search"
          >
            <input
              id="guisearch"
              ref="searchInput"
              v-model="search"
              :placeholder="this.$t('Hledat podle názvu, ID, tagu, …')"
              autofocus
              class="w-100"
              type="text"
              @keyup.enter="searchEndpoints()"
            />
            <div v-if="search" class="atom-icon" @click="clearSearch()">
              <img src="@/assets/icons/actions/ico-close.svg" />
            </div>
            <div class="atom-icon" @click="searchEndpoints()">
              <img src="@/assets/icons/actions/ico-search-black.svg" />
            </div>
            <div class="custom-control--search__suggestions">
              <div
                v-for="(suggestion, index) in suggestionsArray"
                :key="index"
                class="custom-control--search__suggestions__item"
                @click="setSuggestion(suggestion)"
              >
                <span>{{ suggestion }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="layout__content__content pt-5 px-0">
      <div v-if="selectable" v-click-outside="closeDropdownActions" class="dropdown-actions">
        <button v-if="selectedRows.length > 0" class="btn btn-primary" @click="showDropdownActions()">
          <div class="d-flex align-items-center">
            {{ $t("hromadneAkce") }}
            <img class="ml-2" src="@/assets/icons/arrows/arr-down-white.svg" />
          </div>
        </button>
        <button v-else class="btn btn-primary" disabled>
          <div class="d-flex align-items-center">
            {{ $t("hromadneAkce") }}
            <img class="ml-2" src="@/assets/icons/arrows/arr-down-white.svg" />
          </div>
        </button>
        <div
          v-if="isActionsDropdownVisible && selectedRows.length > 0"
          class="dropdown-actions__wrapper dropdown-actions__wrapper--wide"
        >
          <div class="dropdown-actions__inner">
            <div class="row">
              <div
                class="dropdown-actions__item d-flex align-items-center col-6"
                @click="
                  () => {
                    actionItems = selectedRows
                    toggleAddToGroupsModal('addToGroups')
                  }
                "
              >
                <div class="atom-icon">
                  <img src="@/assets/icons/actions/ico-ico-zmenaskupiny.svg" />
                </div>
                {{ $t("priraditKeSkupine") }}
              </div>
              <div
                class="dropdown-actions__item d-flex align-items-center col-6"
                @click="
                  () => {
                    actionItems = selectedRows
                    switchEndpoints(true)
                    showDropdownActions()
                  }
                "
              >
                <div class="atom-icon">
                  <img src="@/assets/icons/actions/ico-ico-zmenarezimu.svg" />
                </div>
                {{ $t("zapnout") }}
              </div>
              <div
                class="dropdown-actions__item d-flex align-items-center col-6"
                @click="
                  () => {
                    actionItems = selectedRows
                    toggleRemoveFromGroupsModal('removeFromGroups')
                  }
                "
              >
                <div class="atom-icon">
                  <img src="@/assets/icons/actions/ico-ico-zmenaskupiny.svg" />
                </div>
                {{ $t("odebratZeSkupiny") }}
              </div>
              <!--b-col cols="6" class="dropdown-actions__item d-flex align-items-center" @click="actionItems = selectedRows;toggleSideBox(1)">
                <div class="atom-icon">
                  <img src="@/assets/icons/actions/ico-ico-label.svg">
                </div>
                {{ $t("odebratTag") }}
              </b-col-->
              <div
                class="dropdown-actions__item d-flex align-items-center col-6"
                @click="
                  () => {
                    actionItems = selectedRows
                    switchEndpoints(false)
                    showDropdownActions()
                  }
                "
              >
                <div class="atom-icon">
                  <img src="@/assets/icons/actions/ico-ico-zmenarezimu.svg" />
                </div>
                {{ $t("vypnout") }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="selectable" class="d-flex align-items-center justify-content-end mb-4">
        <span class="font-weight-light">{{ $t("vybrano") }}: {{ selectedRows.length }}</span>
        <span v-if="selectedRows.length != sortedEndpoints.length" class="link ml-4" @click="selectAll('selectAll')">
          {{ $t("vybratVse") }}
        </span>
        <span v-if="selectedRows.length > 0" class="link ml-2" @click="selectAll('deselect')">
          {{ $t("OdvybratVse") }}
        </span>
      </div>

      <div v-if="allEndpoints.length > 0" class="position-relative w-100">
        <div id="endpoints" class="table-responsive">
          <table class="table table-main table-hover">
            <thead>
              <tr>
                <th
                  v-for="(column, index) in columns"
                  :key="index"
                  :class="{ isHidden: !column.visible }"
                  :style="{ 'min-width': column.minWidth }"
                >
                  <span v-if="column.sortable != true">
                    {{ $t(column.name) }}
                  </span>
                  <span v-else>
                    <div
                      v-if="column.name == 'custDestName'"
                      :class="{ checked: allOnPageSelected() }"
                      class="custom-control custom-control--checkbox"
                      @click="selectAll()"
                    >
                      <input class="custom-control-input" type="checkbox" />
                    </div>
                    <div class="title" @click="sortBy(column.type)">
                      {{ $t(column.name) }}
                    </div>
                    <div v-if="sort == column.type" class="sorting">
                      <span v-if="sortType == 'desc'">▼</span>
                      <span v-if="sortType == 'asc'">▲</span>
                    </div>
                  </span>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, item_index) in sortedEndpoints.slice(
                  this.page * Number(this.rowsPerPage),
                  this.page * Number(this.rowsPerPage) + Number(this.rowsPerPage)
                )"
                :key="item_index"
              >
                <td
                  v-for="(column, column_index) in columns"
                  :key="column_index"
                  :class="{
                    isHidden: !column.visible,
                    disabledEndpoint: !item.custDestEnabled,
                    'position-relative endpointName': column.type == 'custDestName'
                  }"
                  :style="{ width: column.minWidth }"
                >
                  <span v-if="column.type == 'custDestName'" :class="{ disabledEndpoint: !item.custDestEnabled }">
                    <div
                      :class="{
                        checked: selectedRows.filter((e) => e.custDestId === item.custDestId).length > 0
                      }"
                      class="custom-control custom-control--checkbox"
                      style="display: inline-block"
                      @click="addToSelected(item)"
                    >
                      <input class="custom-control-input" type="checkbox" />
                    </div>

                    <RouterLink
                      :to="{
                        name: 'endpoint',
                        params: {
                          id: item.custDestId,
                          device: item,
                          customerId: customerId,
                          projectId: projectId
                        }
                      }"
                      class="font-weight-bolder link-gray"
                    >
                      <span :style="{ maxWidth: column.minWidth }" style="display: block; word-wrap: break-word">
                        {{ item[column.type] }}
                      </span>
                    </RouterLink>
                  </span>
                  <span v-else-if="column.type == 'custDestId'">
                    <div v-tooltip :title="item.custDestId">
                      <span class="eui-short">
                        {{ $filters.strLimitEnd(item.custDestId, 6) }}
                      </span>
                    </div>
                  </span>
                  <div v-else-if="column.type == 'deviceGroups'">
                    <div
                      v-for="group in item.deviceGroups.slice(0, 1)"
                      :key="group.deviceGroupId + 'g' + item.custDestId"
                      class="d-flex"
                    >
                      <a
                        class="link-gray"
                        @click="
                          $router.push({
                            name: 'group',
                            params: { id: group.deviceGroupId, group: group }
                          })
                        "
                      >
                        <span>
                          {{ $filters.strLimit(group.deviceGroupName, 11) }}
                        </span>
                      </a>
                      <div v-if="item.deviceGroups.length > 1" class="atom-expand" @click="toggleGroup(item)">
                        <span v-if="openedGroups.indexOf(item) > -1">-</span>
                        <span v-else>+</span>
                        {{ item.deviceGroups.length - 1 }}
                      </div>
                    </div>

                    <div v-if="openedGroups.indexOf(item) > -1" class="atom-expand__content d-flex flex-wrap">
                      <div
                        v-for="group in item.deviceGroups.slice(1, item.deviceGroups.length)"
                        :key="group.deviceGroupId + 'g' + item.custDestId"
                        class=""
                      >
                        <a
                          class="link-gray"
                          @click="
                            $router.push({
                              name: 'group',
                              params: {
                                id: group.deviceGroupId,
                                group: group
                              }
                            })
                          "
                        >
                          <span>{{ group.deviceGroupName }}</span>
                        </a>
                      </div>
                    </div>

                    <div class="" />
                  </div>
                  <span v-else-if="column.type == 'url'">
                    <div v-tooltip :title="item.custDestParameters.url">
                      <span v-if="item.custDestParameters.url">
                        {{ $filters.strLimitEnd(item.custDestParameters.url, 36) }}
                      </span>
                      <span v-else-if="item.custDestParameters.address">
                        {{ $filters.strLimitEnd(item.custDestParameters.address, 36) }}
                      </span>
                    </div>
                    <div
                      v-if="item.custDestParameters.url"
                      class="copy d-flex align-items-center ml-1"
                      @click="copyToClipboard(item.custDestParameters.url)"
                    >
                      <img src="@/assets/icons/actions/ico-ico-copy.svg" />
                    </div>
                  </span>
                  <span v-else>
                    {{ item[column.type] }}
                  </span>
                </td>
                <td>
                  <div
                    id="kebab"
                    ref="kebab"
                    :class="{
                      opened: openedEndpoint.custDestId == item.custDestId
                    }"
                    class="kebab"
                  />
                </td>
              </tr>
            </tbody>
          </table>

          <table :class="{ showShadow: showShadow }" class="table table-hover fixed-first-column">
            <thead>
              <tr>
                <th>
                  <span v-if="columns[0].sortable != true">
                    {{ $t(columns[0].name) }}
                  </span>
                  <span v-else class="d-flex align-items-center">
                    <div
                      v-if="columns[0].name == 'custDestName'"
                      :class="{
                        checked: allOnPageSelected()
                      }"
                      class="custom-control custom-control--checkbox"
                      @click="selectAll()"
                    >
                      <input class="custom-control-input" type="checkbox" />
                    </div>
                    <div class="title" @click="sortBy(columns[0].type)">
                      {{ $t(columns[0].name) }}
                    </div>
                    <div v-if="sort == columns[0].type" class="sorting">
                      <span v-if="sortType == 'desc'">▼</span>
                      <span v-if="sortType == 'asc'">▲</span>
                    </div>
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, item_index) in sortedEndpoints.slice(
                  this.page * Number(this.rowsPerPage),
                  this.page * Number(this.rowsPerPage) + Number(this.rowsPerPage)
                )"
                :key="item_index"
              >
                <td
                  :class="{ disabledEndpoint: !item.custDestEnabled }"
                  :style="{ width: columns[0].minWidth }"
                  class="position-relative endpointName"
                >
                  <span>
                    <div
                      :class="{
                        checked: selectedRows.filter((e) => e.custDestId === item.custDestId).length > 0
                      }"
                      class="custom-control custom-control--checkbox"
                      style="display: inline-block"
                      @click="addToSelected(item)"
                    >
                      <input class="custom-control-input" type="checkbox" />
                    </div>

                    <RouterLink
                      :to="{
                        name: 'endpoint',
                        params: {
                          id: item.custDestId,
                          device: item,
                          customerId: customerId,
                          projectId: projectId
                        }
                      }"
                      class="font-weight-bolder link-gray"
                    >
                      <span :style="{ maxWidth: columns[0].minWidth }" style="display: block; word-wrap: break-word">
                        {{ item.custDestName }}
                      </span>
                    </RouterLink>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>

          <table :class="{ showShadow: showShadow }" class="table table-hover fixed-last-column">
            <thead>
              <tr>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, item_index) in sortedEndpoints.slice(
                  this.page * Number(this.rowsPerPage),
                  this.page * Number(this.rowsPerPage) + Number(this.rowsPerPage)
                )"
                :key="item_index"
              >
                <td>
                  <div
                    id="kebab"
                    ref="kebab"
                    :class="{
                      opened: openedEndpoint.custDestId == item.custDestId
                    }"
                    class="kebab"
                  >
                    <div class="dropdown-actions">
                      <div class="atom-icon mr-0" @click="openKebab(item)">
                        <img src="@/assets/icons/menu/ico-kebab.svg" />
                      </div>

                      <div
                        v-if="openedEndpoint.custDestId == item.custDestId"
                        v-click-outside="closeKebabConf"
                        class="dropdown-actions__wrapper"
                      >
                        <div class="dropdown-actions__inner">
                          <div
                            class="dropdown-actions__item d-flex align-items-center cursor"
                            @click="actionItems = [openedEndpoint]"
                          >
                            <StateSwitcher
                              :text="true"
                              :value="openedEndpoint.custDestEnabled"
                              @switch="switchEndpoints"
                            />
                          </div>
                          <div
                            class="dropdown-actions__item d-flex align-items-center"
                            @click="
                              () => {
                                actionItems = [openedEndpoint]
                                toggleEditEndpointModal('editEndpoint', item.protocol)
                              }
                            "
                          >
                            <div class="atom-icon">
                              <img src="@/assets/icons/actions/ico-ico-upravitzarizeni.svg" />
                            </div>
                            {{ $t("upravitEndpoint") }}
                          </div>
                          <div
                            v-if="openedEndpoint.protocol === 'HTTP'"
                            class="dropdown-actions__item d-flex align-items-center"
                            @click="
                              () => {
                                actionItems = [openedEndpoint]
                                ping()
                              }
                            "
                          >
                            <div class="atom-icon">
                              <img src="@/assets/icons/actions/ico-ico-ping-orange.svg" />
                            </div>
                            {{ $t("ping") }}
                          </div>
                          <div
                            class="dropdown-actions__item d-flex align-items-center col-6"
                            @click="
                              () => {
                                actionItems = [openedEndpoint]
                                toggleRemoveEndpointFromGroup([item])
                              }
                            "
                          >
                            <div class="atom-icon">
                              <img src="@/assets/icons/actions/ico-ico-delete-l.svg" />
                            </div>
                            {{ $t("odebratEndpointOdSkupiny") }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div
        v-if="allEndpoints.length > 0"
        class="custom-table__footer d-flex align-items-center justify-content-between"
      >
        <div class="custom-table__footer__actions align-items-center">
          <p v-if="!toggledAllRows" class="link-gray mb-0" @click="toggleAllRows()">
            <span>{{ $t("rozbalitVsechnyRadky") }}</span>
          </p>
          <p v-if="toggledAllRows" class="link-gray mb-0" @click="toggleAllRows()">
            <span>{{ $t("sbalitVsechnyRadky") }}</span>
          </p>
        </div>
        <Paging
          :page="{
            currentPage: page,
            rowsPerPage: rowsPerPage,
            itemsTotalCount: allEndpoints.length,
            itemsCount: allEndpoints.length
          }"
          @next-page="page++"
          @page="page = $event"
          @prev-page="page--"
          @rows-per-page="rowsPerPage = $event"
        />
      </div>

      <div v-else-if="!loadingData" class="my-5">
        {{ $t("zadneEndpointyGroup") }}
      </div>
      <div v-else class="my-5">
        <AppLoader />
      </div>
    </div>
    <AddToGroupsModal
      :endpoints="actionItems"
      :opened="openedAddToGroups"
      :tags="tags"
      @close-box="toggleAddToGroupsModal"
      @open-box="toggleAddToGroupsModal"
      @reload-items="reloadEndpoints"
    />
    <RemoveFromGroupsModal
      :endpoints="actionItems"
      :opened="openedRemoveFromGroups"
      :tags="tags"
      @close-box="toggleRemoveFromGroupsModal"
      @open-box="toggleRemoveFromGroupsModal"
      @reload-items="reloadEndpoints"
    />
    <RemoveEndpointFromGroupModal
      :centered="true"
      :items="actionItems"
      :opened="openedDeleteEndpoint"
      :text="deleteText"
      @close="toggleRemoveEndpointFromGroup()"
      @yes="
        () => {
          removeEndpointFromGroup()
          toggleRemoveEndpointFromGroup()
        }
      "
    />
    <PingEndpointModal
      :centered="true"
      :items="pingResponses"
      :opened="openedPingEndpoint"
      :text="deleteText"
      @close="closePingModal"
      @repeat="pingRepeat"
    />
    <EditEndpointModal
      v-if="openedEditEndpoint.length > 0"
      :opened="openedEditEndpoint"
      :original-endpoint="actionItems[0]"
      :protocol="editEndpointProtocol"
      @close-box="toggleEditEndpointModal"
      @open-box="toggleEditEndpointModal"
      @reload-items="reloadEndpoints"
    />
    <div v-if="errorsToTranslate.length > 0">
      <ErrorModal :centered="true" :errors="errorsToTranslate" :opened="openedError" @close="openedError = false" />
    </div>
  </div>
</template>

<script>
import axios from "axios"
import _ from "lodash"
import Paging from "@/components/paging/paging.vue"
import RemoveEndpointFromGroupModal from "@/components/confirmations/remove.vue"
import PingEndpointModal from "@/components/confirmations/ping.vue"
import EditEndpointModal from "@/components/modals/endpoints/edit.vue"
import AddToGroupsModal from "@/components/modals/endpoints/addToGroups.vue"
import RemoveFromGroupsModal from "@/components/modals/endpoints/removeFromGroups.vue"
import Switcher from "@/components/switcher.vue"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
import Notify from "@/components/notify/notify.vue"
import Loader from "@/components/loader.vue"
import { useProjectStore } from "@/store/modules/project"
import { useEndpointsStore } from "@/store/modules/endpoints"

export default {
  directives: {},
  components: {
    Paging,
    RemoveEndpointFromGroupModal,
    PingEndpointModal,
    EditEndpointModal,
    AddToGroupsModal,
    RemoveFromGroupsModal,
    StateSwitcher: Switcher,
    ErrorModal,
    CopyNotification: Notify,
    AppLoader: Loader
  },
  props: {
    allEndpoints: Array,
    group: Object,
    selectable: Boolean
  },
  setup() {
    const projectStore = useProjectStore()
    const endpointsStore = useEndpointsStore()

    return { projectStore, endpointsStore }
  },
  data() {
    return {
      tableWidth: 0,
      columns: [
        {
          type: "custDestName",
          name: "custDestName",
          sortable: true,
          visible: true,
          minWidth: "250px",
          order: 1
        },
        {
          type: "custDestId",
          name: "custDestId",
          sortable: true,
          visible: true,
          minWidth: "120px",
          order: 2
        },
        {
          type: "protocol",
          name: "protocol",
          sortable: false,
          visible: true,
          minWidth: "100px",
          order: 3
        },
        {
          type: "deviceGroups",
          name: "deviceGroups",
          sortable: false,
          visible: true,
          minWidth: "200px",
          order: 4
        },
        {
          type: "url",
          name: "DESTINATION",
          sortable: false,
          visible: true,
          minWidth: "400px",
          order: 5
        }
      ],
      projectId: this.$route.params.projectId,
      customerId: this.$route.params.customerId,
      editEndpointProtocol: "",
      search: "",
      suggested: "",
      suggestionsArray: [],
      isActionsDropdownVisible: false,
      sort: "custDestName",
      sortType: "asc",
      rowsPerPage: 20,
      page: 0,
      openedRowsSelect: false,
      selectedRows: [],
      selectedAll: false,
      isSelectedAllOnPage: false,
      openedSideBox: false,
      openedEndpoint: {},
      openedGroups: [],
      openedTags: [],
      toggledAllRows: false,
      openedNewEndpoint: [],
      tags: [],
      toDelete: [],
      openedDeleteEndpoint: false,
      deleteText: "",
      pingResponses: [],
      openedPingEndpoint: false,
      openedEditEndpoint: [],
      openedAddToGroups: [],
      openedRemoveFromGroups: [],
      copyConfirmVisible: false,
      actionItems: [],
      errorsToTranslate: [],
      openedError: false,
      sortedEndpoints: [],
      closeKebabConf: {
        handler: this.closeKebab,
        middleware: this.middlewareKebab,
        events: ["dblclick", "click"],
        isActive: true,
        detectIFrame: true,
        capture: false
      },
      loadingData: true,
      tableColumnsDefault: {
        custDestId: {
          show: true,
          order: 2,
          title: "custDestId"
        },
        protocol: {
          show: true,
          order: 3,
          title: "protocol"
        },
        deviceGroups: {
          show: true,
          order: 4,
          title: "deviceGroups"
        },
        url: {
          show: true,
          order: 5,
          title: "DESTINATION"
        }
      },
      showSidebarTableColumnOrder: false,
      tableColumns: {},
      showShadow: false
    }
  },
  computed: {
    endpointsCount() {
      return this.endpointsStore.allEndpointsCount
    },
    openNewEndpointModalOnLoad() {
      return this.$store.getters["modals/ifNewEndpointVisible"]
    },
    project() {
      return this.projectStore.selectedProject
    }
  },
  watch: {
    search() {
      if (this.suggested == "") {
        if (this.search.length > 1) {
          this.suggestions()
        }
      } else {
        this.suggested = ""
      }
    },
    project() {
      this.loadEndpoints()
      this.selectedRows = []
    },
    sort() {
      this.endpointsStore.getAllEndpoints({
        sort: this.sort,
        rowsPerPage: 1000,
        currentPage: 0
      })
      this.endpointsStore.getMqttGateways({
        sort: this.sort,
        rowsPerPage: 1000,
        currentPage: 0
      })
    },
    rowsPerPage() {
      this.page = 0
      localStorage.rowsPerPage = this.rowsPerPage
    },
    page() {
      this.isSelectedAllOnPage = false
      var selectedDevices = this.allEndpoints.slice(
        this.page * this.rowsPerPage,
        this.page * this.rowsPerPage + this.rowsPerPage
      )
      let selectedDevicesId = selectedDevices.map((d) => d.custDestId)
      let selectedAllRowsArray = Array.from(this.selectedRows)
      let allEndpointsId = selectedAllRowsArray.map((d) => d.custDestId)
      this.isSelectedAllOnPage = selectedDevicesId.every((ai) => allEndpointsId.includes(ai)) ? true : false
    },
    allEndpoints() {
      this.getAllTags()
    },
    isActionsDropdownVisible() {
      if (this.isActionsDropdownVisible == true) {
        this.openedEndpoint = {}
      }
    },
    openNewEndpointModalOnLoad() {
      if (this.openNewEndpointModalOnLoad) {
        this.createNewEndpoint()
        this.$store.commit("modals/setNewEndpointVisible", {
          showNewEndpoint: false
        })
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.updateResponsiveTable)
      window.addEventListener("click", this.updateResponsiveTable)
    })

    if (localStorage.rowsPerPage) {
      var rows1 = localStorage.rowsPerPage
      this.rowsPerPage = rows1
    } else {
      localStorage.rowsPerPage = this.rowsPerPage
    }
    if (this.project) {
      this.loadEndpoints()
    }

    if (this.openNewEndpointModalOnLoad) {
      this.createNewEndpoint()
      this.$store.commit("modals/setNewEndpointVisible", {
        showNewEndpoint: false
      })
    }
  },
  methods: {
    updateResponsiveTable() {
      this.$updateResponsiveTable(this, "endpoints")
    },
    async loadEndpoints() {
      let isHttpLoaded = await this.endpointsStore.getAllEndpoints({ sort: this.sort, rowsPerPage: 1000, currentPage: 0 })
      let isMqttLoaded = await this.endpointsStore.getMqttGateways({ sort: this.sort, rowsPerPage: 1000, currentPage: 0 })

      if (isHttpLoaded && isMqttLoaded) {
        this.loadingData = false
        this.sortedEndpoints = [].concat(this.allEndpoints)
        console.log("loadEndpoints()")
        console.log(this.sortedEndpoints)
        this.getAllTags()
        this.$nextTick(() => {
          this.updateResponsiveTable()
        })
      }
    },
    searchEndpoints() {
      this.page = 0
      this.suggestionsArray = []
      this.sortedEndpoints = this.allEndpoints.filter(
        (endpoint) => endpoint.custDestName.toLowerCase().indexOf(this.search.toLowerCase()) !== -1
      )
    },
    reloadEndpoints() {
      console.log("reloadEndpoints")
      this.openedNewEndpoint = []
      this.openedAddToGroups = []
      this.openedRemoveFromGroups = []
      this.loadEndpoints()
      this.$parent.loadGroup()
    },
    async suggestions() {
      const httpEndpointsResponse = await axios.get(
        `${process.env.VUE_APP_API}/http/endpoints/suggestions?search=${this.search}*`
      )
      const mqttGateways = await axios.get(
        `${process.env.VUE_APP_API}/mqtt/gateways/suggestions?search=${this.search}*`
      )

      this.suggestionsArray = [...httpEndpointsResponse.data.data, ...mqttGateways.data.data]
    },
    setSuggestion(suggestion) {
      this.suggested = suggestion
      this.search = suggestion
      this.searchEndpoints()
      this.suggestionsArray = []
    },
    clearSearch() {
      this.search = ""
      this.suggested = ""
      this.searchEndpoints()
      this.suggestionsArray = []
    },
    showDropdownActions() {
      this.isActionsDropdownVisible = !this.isActionsDropdownVisible
    },
    sortBy(sortBy) {
      let sorted
      this.isSelectedAllOnPage = false
      this.sort = sortBy
      if (this.sortType === "asc") {
        sorted = _.orderBy(this.sortedEndpoints, `${sortBy}`, "desc")
        this.sortType = "desc"
      } else {
        sorted = _.orderBy(this.sortedEndpoints, `${sortBy}`, "asc")
        this.sortType = "asc"
      }
      this.dateChanged = false
      this.sortedEndpoints = sorted
    },
    toggleOpenedRowSelect() {
      this.openedRowsSelect = this.openedRowsSelect ? false : true
    },
    addToSelected(device) {
      if (this.selectedRows.filter((e) => e.custDestId === device.custDestId).length > 0) {
        const index = this.selectedRows.map((e) => e.custDestId).indexOf(device.custDestId)

        this.selectedRows.splice(index, 1)
      } else {
        this.selectedRows.push(device)
      }
    },
    toggleGroup(device) {
      var index = this.openedGroups.indexOf(device)
      if (this.openedGroups.indexOf(device) > -1) {
        this.openedGroups.splice(index, 1)
        if (this.toggledAllRows) this.toggledAllRows = false
      } else {
        this.openedGroups.push(device)
      }
    },
    toggleTag(device) {
      var index = this.openedTags.indexOf(device)
      if (this.openedTags.indexOf(device) > -1) {
        this.openedTags.splice(index, 1)
        if (this.toggledAllRows) this.toggledAllRows = false
      } else {
        this.openedTags.push(device)
      }
    },
    toggleAllRows() {
      if (this.toggledAllRows) {
        this.openedTags = []
        this.openedGroups = []
        this.toggledAllRows = false
      } else {
        this.openedTags = [].concat.apply([], this.allEndpoints)
        this.openedGroups = [].concat.apply([], this.allEndpoints)
        this.toggledAllRows = true
      }
    },
    selectAll(type) {
      this.isSelectedAllOnPage = true
      var selectedDevices = this.allEndpoints.slice(
        this.page * this.rowsPerPage,
        Number(this.page * this.rowsPerPage) + Number(this.rowsPerPage)
      )
      let selectedDevicesId = selectedDevices.map((d) => d.custDestId)
      let selectedAllRowsArray = Array.from(this.selectedRows)
      let allEndpointsId = selectedAllRowsArray.map((d) => d.custDestId)
      if (type === "deselect") {
        this.selectedRows = []
        this.isSelectedAllOnPage = false
      } else if (type === "selectAll") {
        this.selectedRows = [].concat.apply([], this.allEndpoints)
        this.isSelectedAllOnPage = true
      } else {
        if (selectedDevicesId.every((ai) => allEndpointsId.includes(ai))) {
          let indexes = []
          selectedDevices.forEach((element) => {
            indexes.push(selectedAllRowsArray.indexOf(element))
          })
          this.selectedRows.splice(indexes[0], indexes.length)
        } else {
          let indexes = []
          let same = []
          this.selectedRows.forEach((selected) => {
            let filteredArray = selectedDevices.filter((e) => e.custDestId === selected.custDestId)
            same.push(filteredArray[0])
          })
          same.forEach((element) => {
            if (element != undefined) {
              indexes.push(this.selectedRows.findIndex((obj) => obj.custDestId == element.custDestId))
            }
          })
          for (var i = indexes.length - 1; i >= 0; i--) {
            this.selectedRows.splice(indexes[i], 1)
          }

          this.selectedRows =
            this.selectedRows.length > 0
              ? this.selectedRows.concat.apply(this.selectedRows, selectedDevices)
              : [].concat.apply([], selectedDevices)
        }
      }
    },
    allOnPageSelected() {
      let itemsOnPage = this.allEndpoints.slice(
        this.page * this.rowsPerPage,
        Number(this.page * this.rowsPerPage) + Number(this.rowsPerPage)
      )

      let itemsOnPageId = itemsOnPage.map((d) => d.custDestId)
      let allItemsId = Array.from(this.selectedRows).map((d) => d.custDestId)

      if (itemsOnPageId.every((ai) => allItemsId.includes(ai))) {
        return true
      } else {
        return false
      }
    },
    openKebab(device) {
      this.openedEndpoint = this.openedEndpoint == device ? {} : device
    },
    closeKebab() {
      this.openedEndpoint = {}
    },
    copyToClipboard(text) {
      this.copyConfirmVisible = true
      navigator.clipboard.writeText(text)
    },
    toggleSideBox(box) {
      this.openedSideBox = box == false ? false : box
    },
    toggleNewEndpoint() {
      this.openedNewEndpoint = this.openedNewEndpoint ? false : true
    },
    getAllTags() {
      this.tags = _(this.allEndpoints)
        .flatMap((f) => f.tags)
        .sortedUniq()
        .value()
    },
    toggleRemoveEndpointFromGroup(items) {
      console.log(items)
      if (this.openedDeleteEndpoint == true) {
        this.openedDeleteEndpoint = false
        this.deleteText = ""
      } else {
        if (items) {
          this.deleteText = items.length > 1 ? "endpointyLabel" : items[0].custDestName
        }
        this.openedDeleteEndpoint = true
      }
    },
    removeEndpointFromGroup() {
      console.log("deleteEndpoint")
      this.errorsToTranslate = []
      let promises = []
      let notifications = []

      this.actionItems.forEach((item) => {
        let id = item.custDestId
        promises.push(
          axios
            .delete(
              process.env.VUE_APP_API + "/device-groups/" + this.group.deviceGroupId + "/endpoints/" + id + "/assign",
              {}
            )
            .then((response) => {
              if (response.status == 204) {
                this.sortedEndpoints.splice(this.sortedEndpoints.indexOf(item), 1)
                notifications.push({
                  text: "notificationEndpointGroupRemove",
                  error: false,
                  params: {
                    custDestId: item.custDestId,
                    custDestName: item.custDestName,
                    deviceGroupId: this.group.deviceGroupId,
                    deviceGroupName: this.group.deviceGroupName
                  }
                })
                this.group.endpoints--
              }
            })
            .catch((error) => {
              let message = error.data.errors[0]
              error.data.errors = []
              error.data.errors.push({
                message: message,
                attribute: {
                  custDestId: item.custDestId,
                  custDestName: item.custDestName
                }
              })
              this.errorsToTranslate.push(error.data)
            })
        )
      })
      Promise.all(promises).then(() => {
        this.$store.commit("modals/setGlobalNotification", notifications)
        this.selectedRows = []
        this.openedError = true
      })
    },
    pingRepeat(item) {
      this.pingResponses.splice(this.pingResponses.indexOf(item), 1)
      this.ping([item])
    },
    closePingModal(item) {
      this.pingResponses.splice(this.pingResponses.indexOf(item), 1)
      if (this.pingResponses.length < 1) {
        this.openedPingEndpoint = false
      }
    },
    ping(endpoint) {
      if (this.isActionsDropdownVisible) {
        this.showDropdownActions()
      }

      let array = endpoint == undefined ? this.actionItems : endpoint

      array.forEach((item) => {
        const id = item.custDestId
        // const urlRoot = item.protocol === 'HTTP' ? '/http/endpoints/' : '/mqtt/gateways/'  // cannot ping mqtt (yet?)
        axios
          .get(`${process.env.VUE_APP_API}/http/endpoints/${id}/ping`, {})
          .then((response) => {
            let obj = {
              endpoint: item,
              response: response.data.status
            }
            this.pingResponses.push(obj)
            this.openedPingEndpoint = true

            this.closeKebab()
          })
          .catch(() => {
            let obj = {
              endpoint: item,
              response: "error"
            }
            this.openedPingEndpoint = true
            this.pingResponses.push(obj)
            this.closeKebab()
          })
      })
    },
    toggleEditEndpointModal(box, protocol) {
      this.editEndpointProtocol = protocol

      if (this.openedEditEndpoint.indexOf(box) > -1) {
        box == undefined
          ? (this.openedEditEndpoint = [])
          : this.openedEditEndpoint.splice(this.openedEditEndpoint.indexOf(box), 1)
        this.selectedRows = []
        this.selectedAll = false
      } else {
        this.openedEditEndpoint.push(box)
      }
    },
    toggleAddToGroupsModal(box) {
      if (this.openedAddToGroups.indexOf(box) > -1) {
        box == undefined
          ? (this.openedAddToGroups = [])
          : this.openedAddToGroups.splice(this.openedAddToGroups.indexOf(box), 1)
        this.isActionsDropdownVisible = false
      } else {
        this.openedAddToGroups.push(box)
      }
    },
    toggleRemoveFromGroupsModal(box) {
      if (this.openedRemoveFromGroups.indexOf(box) > -1) {
        box == undefined
          ? (this.openedRemoveFromGroups = [])
          : this.openedRemoveFromGroups.splice(this.openedRemoveFromGroups.indexOf(box), 1)
        this.isActionsDropdownVisible = false
      } else {
        this.openedRemoveFromGroups.push(box)
      }
    },
    switchEndpoints(value) {
      let array = this.actionItems
      array.forEach((item) => {
        let id = item.custDestId
        item.custDestDescription = ""
        if (value == undefined) {
          item.custDestEnabled = item.custDestEnabled ? false : true
        } else {
          item.custDestEnabled = value
        }
        const urlRoot = item.protocol === "HTTP" ? "/http/endpoints/" : "/mqtt/gateways/"
        axios
          .put(`${process.env.VUE_APP_API}${urlRoot}${id}`, item, {})
          .then(() => {})
          .catch(() => {})
      })
    },
    closeDropdownActions() {
      this.isActionsDropdownVisible = false
    },
    middlewareKebab(event) {
      return event.target.className !== "custom-control-label"
    },
    closeSidebarTableColumnOrder() {
      this.tableColumns = this.getTableColumns()
      console.log("this.tableColumns")
      console.log(this.tableColumns)
      this.showSidebarTableColumnOrder = false
    },
    getTableColumns() {
      const localStorageItemsJSON = localStorage.getItem(this.columnsTypeName)
      if (!localStorageItemsJSON) {
        return this.tableColumnsDefault
      }

      const localStorageItems = JSON.parse(localStorageItemsJSON)

      if (Object.keys(localStorageItems).length === 0) {
        return this.tableColumnsDefault
      }
      return localStorageItems
    }
  }
}
</script>

<style lang="scss" scoped></style>
